import { useEffect, useSyncExternalStore } from "react";

// Ce que la page affiche, pour Nexus : une page publie son contexte (document ouvert,
// slide et bloc regardés…) et le chat le joint à chaque message. Une seule page à la fois.
let current = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener());

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useNexusPageDetails = () => useSyncExternalStore(subscribe, () => current, () => null);

// details : { description, extra: { ...identifiants et état utiles aux outils } }
export const usePublishNexusPage = (details) => {
  const key = details ? JSON.stringify(details) : "";
  useEffect(() => {
    if (!key) return undefined;
    current = JSON.parse(key);
    notify();
    return () => {
      current = null;
      notify();
    };
  }, [key]);
};

// Ouvre le chat Nexus, avec un message prérempli que l'utilisateur relit avant d'envoyer.
export const openNexus = (message) => {
  window.dispatchEvent(new CustomEvent("nexus-open", { detail: { message } }));
};
